import React, { Component } from 'react';
import {
	BrowserRouter as Router,// eslint-disable-line
	Switch, // eslint-disable-line
	Route,
	Link, // eslint-disable-line
	Redirect, // eslint-disable-line
	NavLink
} from 'react-router-dom';
import { confirmation_modal } from './fnc'
import FastEdit from './Pages/ctn/FastEdit_form';
import Compare from './Pages/Compare';
import Repricer from './Pages/Repricer';
import Shopify_promo from './Pages/Shopify_promo';
// import ShopifyOriginUpdate from './Pages/ShopifyOriginUpdate.js';
import ShopifyAlterData from './Pages/ShopifyAlterData.js';
import Backup from './Pages/Backup';
import Graphique from './Pages/Graphique';
import AvgShipping from './Pages/Avg_shipping';
import Ebay from './Pages/Ebay';
import Admin from './Pages/Account';
import AutoCreate_settings from './Pages/AutoCreate_settings';
import MappingBrand from './Pages/mappingBrand';
import Shopify_dt from './Pages/shopify_dt';
import Shopify_tag from './Pages/shopify_tag';
// import Aplus from './Pages/Aplus';
import AplusV2 from './Pages/AplusV2';
import ImagesShopify from './Pages/ImagesShopify';
import BuyXGetY from './Pages/BuyXGetY';
import ShopifyBulkFile from './Pages/shopifyBulkFile';
import ShopifyBulkNewVersion from './Pages/ShopifyBulkNewVersion';
import ShopifyCollectionChanger from './Pages/ShopifyCollectionChanger';
import Logs from './Pages/logs';
import HistorySells from './Pages/historySells';
import EbayListing from './Pages/ctn/eBay/listing/EbayListing';
import ShopifyListing from './Pages/shopifyListing';
import Template from './Pages/template';
import Brand from './Pages/brand';
import ShopifyCollection from './Pages/shopifyCollection';
import Catalog from './Pages/Catalog';
import Crontask from './Pages/Crontask';
import Infrastructure from './Pages/Infrastructure';
import Carrier from './Pages/Carrier';
import ModalFtpFeed from './Pages/ctn/ModalFtpFeed';
import ImgCanvaser from './Pages/ctn/ImgCanvaser';
import FileConvertor from './Pages/ctn/FileConvertor';
import AutoCreate from './Pages/ctn/autoCreate/autoCreate';
import BcomPipeline from './Pages/ctn/autoCreate/BcomPipeline';
import ManufacturerMain from './Pages/ctn/manufacturer/ManufacturerMain';
import PMA from './Pages/PMA.js';
import Reordering from './Pages/Reordering.js';
import PMAList from './Pages/PMAList.js';
import PMAResult from './Pages/PMAResult.js';
import AddToXlsx from './Pages/AddToXlsx.js';
import Themes from './Pages/Themes.js';
import NewPackageArrival from './Pages/NewPackageArrival.js';
import FbaAmazonMinMaxReport from './Pages/FbaAmazonMinMaxReport.js';
import OutlookSignature from './Pages/OutlookSignature.js';
import SpecialCollection from './Pages/SpecialCollection.js';
import SpecialVendorNewItems from './Pages/SpecialVendorNewItems.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faShopify, faEbay } from '@fortawesome/free-brands-svg-icons'
const refConst = require("./constants.js").v


var moment = require('moment');

//import { warn } from '@firebase/database/dist/src/core/util/util';

/*
function handleClick(e) {
	e.preventDefault();
	console.log('The link was clicked.');
}*/

var adminKey = "-MjVxK86GVBUKL5oNU66";
var multiStoreToolsKey = "Multi Store Tools";

class MainMenu extends Component {

	constructor(props) {
		super(props)
		this.state = {
			permissions: this.props.getUser() && this.props.getUser().permissions? this.props.getUser().permissions : []
		}

		this.getMenu = this.getMenu.bind(this);
		this.getLink = this.getLink.bind(this);
		this.filterMenu = this.filterMenu.bind(this);
	}

	filterMenu(e) {
		let searchVal = e.target.value.trim().toLowerCase()
		let root = e.target.closest('#navbarNavAltMarkup')

		if(!root)	return

		let sections = root.querySelectorAll('.list-group')
		sections.forEach((section) => {
			if(section.querySelector('input[type="search"]'))	return

			let items = section.querySelectorAll('.list-group > .list-group-item')
			let visibleCount = 0

			items.forEach((item) => {
				let txt = (item.textContent || '').trim().toLowerCase()
				let show = !searchVal || txt.indexOf(searchVal) !== -1
				item.style.display = show? '' : 'none'
				if(show)	visibleCount++
			})

			section.style.display = visibleCount > 0? '' : 'none'
		})
	}

	getMenu(){
		return {
			"walmart": {
				"Update Prices": {
					"id": 1,
					"group": [
						adminKey
					],
					"nameUi": <span>
						<i className="bi bi-currency-dollar" style={{marginRight: "10px"}}></i>
						Update Prices</span>,
					"link": "/FastEdit/1",
					"route": "/FastEdit/:pageId",
					"obj": () => {
						return <FastEdit
							{...this.props}
							group={this.getMenu().walmart["Update Prices"].group}
						></FastEdit>},
					"index": true,
					"props": [
						"info"
					],
					"hidden": true
				},/*
				"Add items": {
					"group": [adminKey],
					"link": "/FastEdit/2",
					"route": false,
					"obj": false,
					"hidden": true
				},
				"Compare": {
					"group": [adminKey],
					"link": "/FastEdit/3",
					"route": false,
					"obj": false
				},
				"Add price list": {
					"group": [adminKey],
					"link": "/FastEdit/4",
					"route": false,
					"obj": false,
					"hidden": true
				}, */
			},
			"Main": {
				"Catalog": {
					"id": 21,
					"group": [
						adminKey,
						"-MjWDd5MXTvRcLkDQl64", // finale_read
					],
					"nameUi": <span>
						<FontAwesomeIcon
							icon={faHome}
							style={{marginRight: "10px"}}
						/>Catalog</span>,
					"link": "/catalog",
					"route": "/catalog/:sku?",
					"obj": (parent) => <Catalog
						{...this.props}
						parent={parent}
						group={this.getMenu().Main["Catalog"].group}
					></Catalog>
				},
				"Manufacturer": {
					"isBeta": false,
					"id": 56,
					"nameUi": <span>
						<i className="bi bi-building-gear" style={{marginRight: "10px"}}></i>
						Manufacturer {(moment() < moment("2024-06-01")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"group": [
						adminKey,
						"-NwkJFulcOob3wcg_ZLh" // special_manufacturing_read
					],
					"hidden": false,
					"isRedirect": true,
					"link": "/manufacturer",
					"route": "/manufacturer/:idBrand?",
					"obj": (parent) => {
						console.info("this.getMenu()", this.getMenu());
						return <ManufacturerMain
							{...this.props}
							parent={parent}
							group={this.getMenu().Main["Manufacturer"].group}
						></ManufacturerMain>
					}
				}
			},
			"Listing": {
				"Shopify": {
					"id": 14,
					"group": [
						adminKey,
						"-MjVTXBQweEPcKSCGTUH", // shopify_haus_delete
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjWGrJZhs3iSCRBw00j", // walmart_eio_delete
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
					],
					"nameUi": <span>
						<FontAwesomeIcon icon={faShopify} style={{marginRight: "10px"}}/>
						Shopify</span>,
					"isRedirect": true,
					"link": "/shopify",
					"route": "/shopify/:idItem?",
					"obj": (parent) => { return <ShopifyListing
						{...this.props}
						parent={parent}
						group={this.getMenu().Listing["Shopify"].group}
					></ShopifyListing> }
				},
				"ebay": {
					"isBeta": false,
					"id": 37,
					"nameUi": <span>
						<FontAwesomeIcon icon={faEbay} style={{marginRight: "10px"}}/>
						eBay {(moment() < moment("2021-03-09")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"group": [
						adminKey,
						"-MjVTgFHd2akT44hrjKg", // ebay_eio_write
						"-MjVThc5pOvGWLuvi5f1", // ebay_eio_delete
					],
					"isRedirect": true,
					"link": "/ebayListing",
					"route": "/ebayListing/:idItem?",
					"obj": (parent) => { return <EbayListing
						{...this.props}
						parent={parent}
						group={this.getMenu().Listing["ebay"].group}
					></EbayListing> }
				}
			},
			"Shopify": {
				"Shopify Item Changer": {
					"id": 54,
					"isBeta": false,
					"group": [
						adminKey,
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
					],
					"nameUi": <span>
						<i className="bi bi-arrow-left-right" style={{marginRight: "10px"}}></i>
						Collection Changer{(moment() < moment("2023-12-31")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"link": "/shopify_item_mover",
					"route": "/shopify_item_mover",
					"obj": () => { return <ShopifyCollectionChanger
						title={"Shopify Item Mover from Collection A to Collection B"}
						{...this.props}
						group={this.getMenu().Shopify["Shopify Item Changer"].group}
					/>}
				},
				"ShopifyBulkFile": {
					"id": 46,
					"nameUi": <span>
						<i className="bi bi-file-earmark-spreadsheet" style={{marginRight: "10px"}}></i>
						Product Bulk file {(moment() < moment("2021-11-20")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"group": [
						adminKey,
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
					],
					"hidden": false,
					"link": "/shopify_bulk_file",
					"route": "/shopify_bulk_file/:fncName?/:id?",
					"obj": (parent) => { return <ShopifyBulkFile
						{...this.props}
						parent={parent}
						group={this.getMenu().Shopify["ShopifyBulkFile"].group}
					/> }
				},
				"Bulk New Item": {
					"id": 83,
					"nameUi": <span><i className="bi bi-arrow-repeat" style={{marginRight: "10px"}}></i>Bulk New Item {(moment() < moment("2026-08-30")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"group": [adminKey, "-MjVTYrT8L8HguYYrRKE", "-MjH_9MuY646871R7lUA"],
					"link": "/shopify_bulk_new_version",
					"route": "/shopify_bulk_new_version",
					"obj": () => <ShopifyBulkNewVersion {...this.props} group={this.getMenu().Shopify["Bulk New Item"].group} />
				},
				/* "Shopify Origin": {
					"id": 41,
					"group": [
						adminKey,
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
					],
					"nameUi": <span>Shopify Origin {(moment() < moment("2021-11-01")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"link": "/shopify_origin",
					"route": "/shopify_origin",
					"obj": () => { return <ShopifyOriginUpdate
						{...this.props}
						group={this.getMenu().Shopify["Shopify Origin"].group}
					/>},
				}, */
				"Shopify Bulk": {
					"id": 50,
					"group": [
						adminKey,
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
					],
					"nameUi": <span>
						<i className="bi bi-layers-fill" style={{marginRight: "10px"}}></i>
						Product Bulk Prop{(moment() < moment("2022-04-01")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"link": "/shopify_bulk",
					"route": "/shopify_bulk",
					"obj": () => { return <ShopifyAlterData
						title={"Shopify Bulk Property Update"}
						{...this.props}
						group={this.getMenu().Shopify["Shopify Bulk"].group}
					/>}
				},
				"Add to xlsx": {
					"id": 66,
					"group": [
						adminKey
					],
					"nameUi": <span>
						<i className="bi bi-file-earmark-excel-fill" style={{marginRight: "10px"}}></i>
						Add to xlsx{(moment() < moment("2025-06-05")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"link": "/add_to_xlsx",
					"route": "/add_to_xlsx",
					"obj": () => { return <AddToXlsx
						title={"Add to xlsx"}
						{...this.props}
						group={this.getMenu().Shopify["Add to xlsx"].group}
					/>}
				},
				"Shopify promo": {
					"id": 35,
					"group": [
						adminKey,
						"-Mj_tL_BeXYP4sYC2EUi", // promo_access
					],
					"nameUi": <span>
						<i className="bi bi-tag-fill" style={{marginRight: "10px"}}></i>
						Promo {(moment() < moment("2021-08-01")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"link": "/shopify_promo",
					"route": "/shopify_promo",
					"obj": () => { return <Shopify_promo
						{...this.props}
						group={this.getMenu().Shopify["Shopify promo"].group}
					/>},
				},
				/* "Aplus": {
					"id": 44,
					"nameUi": <span>A+</span>,
					"group": [
						adminKey,
						"-MjWFVGky1zywg_XWuXV", // aplus_delete
						"-MjWFT026EiVCG7YuSl8", // aplus_read
						"-MjWFTo6mm3cEvCZp1Xg" // aplus_write
					],
					"hidden": true,
					"link": "/Aplus",
					"route": "/Aplus/:fncName?/:id?",
					"obj": (parent) => { return <Aplus
						{...this.props}
						parent={parent}
						group={this.getMenu().Shopify["Aplus"].group}
					/> }
				}, */
				"AplusV2": {
					"id": 48,
					"nameUi": <span>
						<i className="bi bi-patch-plus-fill" style={{marginRight: "10px"}}></i>
						A+ v2</span>,
					"group": [
						adminKey,
						"-MjWFVGky1zywg_XWuXV", // aplus_delete
						"-MjWFT026EiVCG7YuSl8", // aplus_read
						"-MjWFTo6mm3cEvCZp1Xg" // aplus_write
					],
					"hidden": false,
					"link": "/AplusV2",
					"route": "/AplusV2/:fncName?/:id?/:idVersion?",
					"obj": (parent) => { return <AplusV2
						{...this.props}
						parent={parent}
						group={this.getMenu().Shopify["AplusV2"].group}
					/> }
				},
				"Images": {
					"id": 52,
					"nameUi": <span>
						<i className="bi bi-images" style={{marginRight: "10px"}}></i>
						Images</span>,
					"group": [
						adminKey,
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
					],
					"hidden": false,
					"link": "/Images",
					"route": "/Images/:fncName?/:id?/:idVersion?",
					"obj": (parent) => { return <ImagesShopify
						{...this.props}
						parent={parent}
						group={this.getMenu().Shopify["AplusV2"].group}
					/> },
					"isBeta": false
				},
				"Themes": {
					"id": 67,
					"nameUi": <span>
						<i className="bi bi-palette-fill" style={{marginRight: "10px"}}></i>
						Themes</span>,
					"group": [
						adminKey,
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
					],
					"hidden": false,
					"link": "/Themes",
					"route": "/Themes/:fncName?/:id?/:idVersion?",
					"obj": (parent) => { return <Themes
						{...this.props}
						parent={parent}
						group={this.getMenu().Shopify["Themes"].group}
					/> },
					"isBeta": false
				},
				"BuyXGetY": {
					"id": 53,
					"nameUi": <span>
						<i className="bi bi-gift-fill" style={{marginRight: "10px"}}></i>
						Buy X Get Y</span>,
					"group": [
						adminKey,
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
					],
					"hidden": false,
					"link": "/BuyXGetY",
					"route": "/BuyXGetY/:fncName?/:id?/:idVersion?",
					"obj": (parent) => { return <BuyXGetY
						{...this.props}
						parent={parent}
						group={this.getMenu().Shopify["BuyXGetY"].group}
					/> },
					// "isBeta": true
				},
				"Special Collection": {
					"id": 72,
					"nameUi": <span>
						<i className="bi bi-grid-3x3-gap-fill" style={{marginRight: "10px"}}></i>
						Special Collection{(moment() < moment("2026-09-01")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"group": [
						adminKey,
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
					],
					"hidden": false,
					"link": "/special_collection",
					"route": "/special_collection",
					"obj": () => { return <SpecialCollection
						title={"Special Collection"}
						{...this.props}
						group={this.getMenu().Shopify["Special Collection"].group}
					/> },
					"isBeta": false
				},
				"Theme Features": {
					"id": 73,
					"nameUi": <span><i className="bi bi-stars" style={{marginRight: "10px"}}></i>Theme Features{(moment() < moment("2026-12-01")? <span className="badge badge-info ml-2">New</span> : '')}</span>,
					"group": [adminKey, "-MjVTYrT8L8HguYYrRKE", "-MjH_9MuY646871R7lUA"],
					"hidden": false,
					"link": "/special_vendor_new_items",
					"route": "/special_vendor_new_items",
					"obj": () => <SpecialVendorNewItems {...this.props} group={this.getMenu().Shopify["Theme Features"].group} />,
					"isBeta": false
				},
			},
			"Divers": {
				"backup": {
					"id": 7,
					"link": "/Backup",
					"route": "/Backup",
					"obj": () => { return <Backup
						{...this.props}
						group={this.getMenu().Divers["backup"].group}
					></Backup>},
					"hidden": true
				}
			},
			[multiStoreToolsKey]: {
				"Update Finale Qty": {
					"id": 22,
					"group": [
						adminKey,
						"-MjWDdyYa7UJHb-U4XwU", // finale_write
					],
					"nameUi": <span>
						<i className="bi bi-box-seam" style={{marginRight: "10px"}}></i>
						Update Finale Qty</span>,
					"link": "/FastEdit/5",
					"route": false,
					"obj": false
				},
				"PMAList": {
					"id": 60,
					"group": [
						adminKey,
						"-ON1ooM28ImOPv2RwjN_",
						"-ON1opT7OdgDxJuqWsBJ",
						"-ON1osxRg9LgrNbaQvYW",
						"-ON1qrQ9xBbT0EbKFaTH"
					],
					"isRedirect": true,
					"link": "/PMAList",
					"route": "/PMAList/:idPma?",
					"hidden": false,
					"isDemo": false,
					"isBeta": true,
					"nameUi": <span>
						<i className="bi bi-clipboard-data-fill" style={{marginRight: "10px"}}></i>
						PMA</span>,
					"obj": (parent) => { return <PMAList 
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["PMAList"].group}
					></PMAList> },
				},
				"PMA": {
					"id": 60,
					"group": [
						adminKey,
						"-ON1ooM28ImOPv2RwjN_",
						"-ON1opT7OdgDxJuqWsBJ",
						"-ON1osxRg9LgrNbaQvYW",
						"-ON1qrQ9xBbT0EbKFaTH"
					],
					"isRedirect": true,
					"link": "/PMA",
					"route": "/PMA/:idPma?",
					"hidden": true,
					"isDemo": true,
					"isBeta": true,
					"nameUi": <span>
						<i className="bi bi-clipboard-data-fill" style={{marginRight: "10px"}}></i>
						PMA</span>,
					"obj": (parent) => { return <PMA 
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["PMA"].group}
					></PMA> },
				},
				"PMAResult": {
					"id": 62,
					"group": [
						adminKey,
						"-ON1qrQ9xBbT0EbKFaTH"
					],
					"isRedirect": true,
					"link": "/PMAResult",
					"route": "/PMAResult/:idPma?",
					"hidden": true,
					"isBeta": true,
					"nameUi": <span>
						<i className="bi bi-graph-up-arrow" style={{marginRight: "10px"}}></i>
						PMA Result</span>,
					"obj": (parent) => { return <PMAResult 
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["PMAResult"].group}
					></PMAResult> },
				},
				"Reordering": {
					"id": 63,
					"group": [
						adminKey,
						"-OSKSGdWekoA7upiTYT5", // reordering_read
						"-OSKSI7G-EXF8QQELYhP", // reordering_write
					],
					"isRedirect": true,
					"link": "/Reordering",
					"route": "/Reordering/:idSupplier?",
					"isBeta": true,
					"nameUi": <span>
						<i className="bi bi-arrow-repeat" style={{marginRight: "10px"}}></i>
						Reordering</span>,
					"obj": (parent) => { return <Reordering 
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["Reordering"].group}
					></Reordering> },
				},
				"AutoCreate": {
					"id": 51,
					"group": [
						adminKey,
						"-NsKsFX4KoU9daC-oZ7L",
					],
					"isRedirect": true,
					"link": "/auto_create",
					"route": "/auto_create/:ctn?",
					"hidden": false,
					"isDemo": false,
					"isBeta": false,
					"nameUi": <span>
						<i className="bi bi-magic" style={{marginRight: "10px"}}></i>
						Auto Creator</span>,
					"obj": (parent) => { return <AutoCreate 
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["AutoCreate"].group}
					></AutoCreate> },
					"protectMenu": true
				},
				"Forecaster": {
					"id": 8,
					"group": [
						adminKey,
						"-MjVTrM8OYAasUfiw-r9", // forecaster_access
					],
					"nameUi": <span>
						<i className="bi bi-graph-up" style={{marginRight: "10px"}}></i>
						Forecaster</span>,
					"isRedirect": true,
					"link": "/forecaster",
					"route": "/forecaster",
					//"obj": () => { return <Redirect to="http://forecaster.io/index.html" />} 
					"obj": () => {
						const forecasterUrl = refConst.dev
							? "http://localhost/eio/Forecaster/index.php"
							: "https://ff.ehub.work";
						document.cookie = refConst.dev
							? "eio_security_point=true; Path=/"
							: "eio_security_point=true; Domain=ehub.work; Path=/";
						window.open(forecasterUrl, '_blank');
						return false;
					}
				},
				"Forecaster v2": {
					"id": 57,
					"group": [
						adminKey,
						"-MjVTrM8OYAasUfiw-r9", // forecaster_access
					],
					"nameUi": <span>
						<i className="bi bi-graph-up" style={{marginRight: "10px"}}></i>
						Forecaster v2</span>,
					"isRedirect": false,
					"hidden": true,
					"link": "/forecaster_v2",
					"route": "/forecaster_v2",
					//"obj": () => { return <Redirect to="http://forecaster.io/index.html" />} 
					"obj": (parent) => { return <AutoCreate 
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["AutoCreate"].group}
					></AutoCreate> }
				},
				"Graphique From DB": {
					"id": 9,
					"group": [
						adminKey
					],
					"isRedirect": true,
					"hidden": true,
					"link": "/graphique",
					"route": "/graphique/:idStore?",
					"obj": (parent) => { return <Graphique
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["Graphique From DB"].group}
					></Graphique> },
					"isBeta": true
				},
				"AVG Shipping cost": {
					"id": 10,
					"group": [
						adminKey,
						"-Mj_haqzismzadLiujp1", // order_view
					],
					"nameUi": <span>
						<i className="bi bi-truck" style={{marginRight: "10px"}}></i>
						AVG Shipping cost</span>,
					"isRedirect": true,
					"link": "/avg_shipping",
					"route": "/avg_shipping/:idShipping?",
					"obj": (parent) => { return <AvgShipping
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["AVG Shipping cost"].group}
					></AvgShipping> },
					"isBeta": false
				}/* ,
				"eBay": {
					"id": 11,
					"isRedirect": true,
					"link": "/eBay",
					"route": "/eBay/:idShipping?",
					"obj": (parent) => { return <Ebay {...this.props} parent={parent}></Ebay> },
					"isBeta": true
				} */,
				"Account": {
					"id": 12,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/Account",
					"route": "/Account/:idUser?",
					"obj": (parent) => { return <Admin
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["Account"].group}
					/> }
				},
				"AutoCreate_settings": {
					"id": 30,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/AutoCreate_settings",
					"route": "/AutoCreate_settings/:idUser?",
					"obj": (parent) => { return <AutoCreate_settings
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["AutoCreate_settings"].group}
					/> }
				},
				"AutoCreate_3m_bcom": {
					"id": 58,
					"group": [
						adminKey,
						"-NsKsFX4KoU9daC-oZ7L",
					],
					"hidden": true,
					"link": "/auto_create_3m_bcom",
					"route": "/auto_create_3m_bcom",
					"obj": (parent) => { return <BcomPipeline
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["AutoCreate_3m_bcom"].group}
					/> }
				},
				"ShopifyDt": {
					"id": 13,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/Shopify_dt",
					"route": "/Shopify_dt/",
					"obj": (parent) => { return <Shopify_dt
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["ShopifyDt"].group}
					/> }
				},
				"ShopifyTag": {
					"id": 40,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/Shopify_tag",
					"route": "/Shopify_tag/:idGrpOpen?/:idTagOpen?",
					"obj": (parent) => { return <Shopify_tag
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["ShopifyTag"].group}
					/> }
				},
				"MappingBrand": {
					"id": 15,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/MappingBrand",
					"route": "/MappingBrand/",
					"obj": (parent) => { return <MappingBrand
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["MappingBrand"].group}
					/> }
				},
				"Brand": {
					"id": 16,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/brand",
					"route": "/brand/:idBrand?",
					"obj": (parent) => { return <Brand
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["Brand"].group}
					/> }
				},
				"Template": {
					"id": 17,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/template",
					"route": "/template/:idObjOpen?",
					"obj": (parent) => { return <Template
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["Template"].group}
					/> }
				},
				"ShopifyCollection": {
					"id": 18,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/shopifycollection",
					"route": "/shopifycollection/:idObjOpen?",
					"obj": (parent) => { return <ShopifyCollection
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["Template"].group}
					/> }
				},
				"FBA Amazon Min/Max": {
					"id": 70,
					"group": [
						adminKey,
						"-MjWHDikDqGC9nNvtYsu", // amazon eio read
					],
					"isRedirect": true,
					"link": "/fba_amazon_minmax",
					"route": "/fba_amazon_minmax",
					"hidden": false,
					"isBeta": false,
					"nameUi": <span>
						<i className="bi bi-bar-chart-steps" style={{marginRight: "10px"}}></i>
						FBA Amazon Min/Max</span>,
					"obj": (parent) => { return <FbaAmazonMinMaxReport
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["FBA Amazon Min/Max"].group}
					></FbaAmazonMinMaxReport> },
				},
				"Logs": {
					"id": 19,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/Logs",
					"route": [
						"/Logs/:idObjOpen?",
						"/Logs/type/:type?/:level?",
					],
					"obj": (parent) => { return <Logs
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["Logs"].group}
					/> }
				},
				"HistorySells": {
					"id": 20,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/HistorySells",
					"route": "/HistorySells/:idObjOpen?",
					"obj": (parent) => { return <HistorySells
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["HistorySells"].group}
					/> }
				},
				"Compare": {
					"id": 34,
					"group": [
						adminKey,
						"-MjVTgFHd2akT44hrjKg", // ebay_eio_write
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
						"-MjWGqGi59xNbduybZHA", // walmart_eio_write
						"-MjWHEUEG0HJvoZtpe19", // amazon_eio_write
					],
					"nameUi": <span>
						<i className="bi bi-columns-gap" style={{marginRight: "10px"}}></i>
						Compare</span>,
					"link": "/catalog_compare",
					"route": "/catalog_compare",
					"obj": () => { return <Compare
						{...this.props}
						group={this.getMenu()[multiStoreToolsKey]["Compare"].group}
					/>},
				},
				"Repricer": {
					"id": 45,
					"nameUi": <span>
						<i className="bi bi-cash-coin" style={{marginRight: "10px"}}></i>
						Repricer</span>,
					"group": [
						adminKey,
						"-MmU5eTNRDF_8C9PP35e", // reprice_access
						/* "-MjVTgFHd2akT44hrjKg", // ebay_eio_write
						"-MjVTYrT8L8HguYYrRKE", // shopify_haus_write
						"-MjH_9MuY646871R7lUA", // shopify_eio_write
						"-MjWGqGi59xNbduybZHA", // walmart_eio_write
						"-MjWHEUEG0HJvoZtpe19", // amazon_eio_write */
					],
					"link": "/repricer",
					"route": "/repricer",
					"obj": () => { return <Repricer
						{...this.props}
						group={this.getMenu()[multiStoreToolsKey]["Repricer"].group}
					/>},
				},
				"CronTask": {
					"id": 36,
					"group": [
						adminKey
					],
					"nameUi": <span>
						<i className="bi bi-clock-history" style={{marginRight: "10px"}}></i>
						CronTask</span>,
					"link": "/crontask",
					"route": "/crontask",
					"obj": () => { return <Crontask
						{...this.props}
						group={this.getMenu()[multiStoreToolsKey]["CronTask"].group}
					/>},
				},
				"Infrastructure": {
					"id": 39,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/infrastructure",
					"route": "/infrastructure",
					"obj": () => { return <Infrastructure
						{...this.props}
						group={this.getMenu()[multiStoreToolsKey]["Infrastructure"].group}
					/>},
				},
				"Carrier": {
					"id": 47,
					"group": [
						adminKey
					],
					"hidden": true,
					"link": "/carrier",
					"route": "/carrier/:idCarrierOpen?/:idRateOpen?",
					"obj": (parent) => { return <Carrier
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["Carrier"].group}
					/>},
				},
				"New Package Arrival": {
					"id": 69,
					"group": [
						adminKey,
						"-MjWPvGjs-zQ5HuKzmgQ", // app_download
					],
					"isRedirect": true,
					"link": "/new_package_arrival",
					"route": "/new_package_arrival",
					"hidden": false,
					"isBeta": false,
					"nameUi": <span>
						<i className="bi bi-box-arrow-in-down" style={{marginRight: "10px"}}></i>
						New Package Arrival</span>,
					"obj": (parent) => { return <NewPackageArrival
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["New Package Arrival"].group}
					></NewPackageArrival> },
				},
				"Outlook Signatures": {
					"id": 71,
					"group": [
						adminKey,
					],
					"isRedirect": true,
					"link": "/outlook_signatures",
					"route": "/outlook_signatures",
					"hidden": false,
					"isBeta": false,
					"nameUi": <span>
						<i className="bi bi-envelope" style={{marginRight: "10px"}}></i>
						Outlook Signatures</span>,
					"obj": (parent) => { return <OutlookSignature
						{...this.props}
						parent={parent}
						group={this.getMenu()[multiStoreToolsKey]["Outlook Signatures"].group}
					></OutlookSignature> },
				}
			},
			"Download": {
				"eBay app - Windows": {
					"id": 42,
					"group": [
						adminKey,
						"-MjWPvGjs-zQ5HuKzmgQ", // app_download
					],
					"nameUi": <span>
						<i className="bi bi-windows" style={{marginRight: "10px"}}></i>
						eBay app - Windows</span>,
					"isRedirect": false,
					"link": "/eioApp/eio-eBay Setup 1.0.0.exe",
					"download": true,
				},
				"New Arrival - Android": {
					"id": 68,
					"group": [
						adminKey,
						"-MjWPvGjs-zQ5HuKzmgQ", // app_download
					],
					"nameUi": <span>
						<i className="bi bi-android2" style={{marginRight: "10px"}}></i>
						New Arrival - Android</span>,
					"isRedirect": false,
					"link": "/eioApp/EIO Arrival.apk",
					"download": true,
				},
				"From FTP": {
					"id": 43,
					"nameUi": <ModalFtpFeed {...this.props} className="nav-item nav-link pointer" title={<span>
						<i className="bi bi-hdd-network-fill" style={{marginRight: "10px"}}></i>
						From FTP {moment() < moment("2021-01-30")? <span className="badge badge-info ml-2">New</span> : ''}
					</span>}/>,
					"group": [
						adminKey,
						"-MjVTkV8Bbpm074D5AuV", // feed_download
					],
					"isRedirect": false,
				}
			},
			"Media": {
				"Canvaser": {
					"id": 43,
					"nameUi": <ImgCanvaser {...this.props} className="nav-item nav-link pointer" title={<span>
						<i className="bi bi-easel-fill" style={{marginRight: "10px"}}></i>
						Framer {moment() < moment("2021-07-30")? <span className="badge badge-info ml-2">New</span> : ''}
					</span>}/>,
					"isRedirect": false,
				},
				"File Convertor": {
					"id": 55,
					"nameUi": <FileConvertor {...this.props} className="nav-item nav-link pointer" title={<span>
						<i className="bi bi-filetype-json" style={{marginRight: "10px"}}></i>
						File Convertor
					</span>}/>,
					"isRedirect": false,
				}
			}
		}
	}

	getLink(props){

		
		let linksTop = [],
			admin = [],
			menu = this.getMenu(),
			level = this.props.getLevel(),
			levels = this.props.getLevels(),
			// routes = [<Route key="0" exact path='/'><Redirect to="/FastEdit/1" /></Route>]; // Default page <Redirect key="0" exact from="/" to="/FastEdit/1" />
			routes = []; // Default page <Redirect key="0" exact from="/" to="/FastEdit/1" />
			////routes = [<Route key="0" exact path='/' render={menu.walmart["Update Prices"].obj}/>]; // Default page <Redirect key="0" exact from="/" to="/FastEdit/1" />
		
		var menuOut = [];
		
		let idMenuFocused = level? levels[level].index : false

		if(this.state.permissions.length === 0) return {"ctn": routes, "menuTop": linksTop, "menuLeft": menuOut, "admin": admin};

		menuOut.push(
			<div key="menu_filter" className="list-group">
				<div className="list-group-item p-2 bg-dark">
					<div className="input-group input-group-sm">
						<div className="input-group-prepend">
							<span className="input-group-text bg-white">
								<i className="bi bi-search"></i>
							</span>
						</div>
						<input
							type="search"
							className="form-control"
							placeholder="Filter menu"
							onChange={this.filterMenu}
						/>
					</div>
				</div>
			</div>
		)

		admin.push(<NavLink key="menuAdmin_link_HistorySells" to={menu[multiStoreToolsKey].HistorySells.link} className="dropdown-item">History Sells</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_Logs" to={menu[multiStoreToolsKey].Logs.link} activeClassName="active" className="dropdown-item">Logs</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_Admin" to={menu[multiStoreToolsKey].Account.link} className="dropdown-item">Account</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_Shopify_dt" to={menu[multiStoreToolsKey].ShopifyDt.link} className="dropdown-item">Shopify DT</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_Shopify_tag" to={menu[multiStoreToolsKey].ShopifyTag.link} className="dropdown-item">Shopify TAG</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_MappingBrand" to={menu[multiStoreToolsKey].MappingBrand.link} className="dropdown-item">Mapping Brand</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_Template" to={menu[multiStoreToolsKey].Template.link} className="dropdown-item">Template</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_Brand" to={menu[multiStoreToolsKey].Brand.link} className="dropdown-item">Brand</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_ShopifyCollection" to={menu[multiStoreToolsKey].ShopifyCollection.link} className="dropdown-item">Shopify Collection</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_CronTask" to={menu[multiStoreToolsKey].CronTask.link} className="dropdown-item">CronTask</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_Infrastructure" to={menu[multiStoreToolsKey].Infrastructure.link} className="dropdown-item">Infrastructure</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_Carrier" to={menu[multiStoreToolsKey].Carrier.link} className="dropdown-item">Carrier</NavLink>);
		admin.push(<NavLink key="menuAdmin_link_AutoCreate_settings" to={menu[multiStoreToolsKey].AutoCreate_settings.link} className="dropdown-item">Auto Create Settings</NavLink>);

		let event = () => {}
		for (const sectionTitle in menu) {
			if (menu.hasOwnProperty(sectionTitle)) {
				let subMenu = menu[sectionTitle]
				let exit = false
				for (const title in subMenu) {
					if (subMenu.hasOwnProperty(title)) {
						const dataLink = subMenu[title];

						if(location.pathname.indexOf(dataLink.link) !== -1 && "protectMenu" in dataLink && dataLink.protectMenu){
							event = (e, link) => {
								e.preventDefault();
								confirmation_modal(this.props, () => {
									props.history.push(link)
									// window.location.href = link
								});
							}
							exit = true
							break;
						}
					}
				}
				if(exit) break;
			}
		}

		console.info("eventevent", event);

		let index = false;
		for (const sectionTitle in menu) {
			if (menu.hasOwnProperty(sectionTitle)) {
				let linksMain = []
				let subMenu = menu[sectionTitle]
				
				for (const title in subMenu) {
					if (subMenu.hasOwnProperty(title)) {
						const dataLink = subMenu[title];

						// Define the default page depending the level of access.
						if(idMenuFocused && dataLink.id === idMenuFocused){
							index = <Route key="0" exact path='/' render={dataLink.obj}/>
						}

						/* console.info('Permission', this.state.permissions);
						console.info('dataLink.group', dataLink.group); */

						// -----------  Permissions -------------
						
						let authorized = !dataLink.group? true : false;

						if(dataLink.group)
							this.state.permissions.forEach(pUid => {
								if(dataLink.group && dataLink.group.indexOf(pUid) !== -1){
									authorized = true;
									return;
								}
							});

						if(("hidden" in dataLink && dataLink.hidden) || !authorized){
							//continue
						}else{
							let isBeta = "isBeta" in dataLink && dataLink.isBeta? <span className="badge badge-danger ml-3">beta</span> : ''
							let isDemo = "isDemo" in dataLink && dataLink.isDemo? <span className="badge badge-warning ml-3">demo</span> : ''

							if(!dataLink.link){ // For Modal
								linksTop.push(<div key={title} className="breadcrumb-item">{ title }</div>) //  className="active" //  onClick={handleClick}
								linksMain.push(<div key={title} className="list-group-item p-0">{ "nameUi" in dataLink? dataLink.nameUi : title }</div>) //  className="active" //  onClick={handleClick}
							}else if(dataLink.download){ // For Download
								linksTop.push(<div key={title} className="breadcrumb-item"><a download={true} href={dataLink.link}>{ title }</a></div>) //  className="active" //  onClick={handleClick}
								linksMain.push(<div key={title} className="list-group-item p-0"><a download={true} href={dataLink.link} onClick={(e) => event(e, dataLink.link)} className="nav-item nav-link">{ "nameUi" in dataLink? dataLink.nameUi : title }{isBeta}{isDemo}</a></div>) //  className="active" //  onClick={handleClick}
							}else{ // Normal JS link
								linksTop.push(<div key={title} className="breadcrumb-item"><NavLink to={dataLink.link} activeClassName="active">{ title }</NavLink></div>) //  className="active" //  onClick={handleClick}
								linksMain.push(<div key={title} className="list-group-item p-0"><NavLink to={dataLink.link} onClick={(e) => event(e, dataLink.link)} className="nav-item nav-link" activeClassName="active text-light">{ "nameUi" in dataLink? dataLink.nameUi : title }{isBeta}{isDemo}</NavLink></div>) //  className="active" //  onClick={handleClick}
							}
						}
							
						if(dataLink.route)
							//if("isRedirect" in dataLink && dataLink.isRedirect)
							routes.push(<Route exact key={title} path={dataLink.route} data={props} render={dataLink.obj}/>) //  className="active" //  onClick={handleClick}
					}
				}

				if(linksMain.length > 0)
					menuOut.push(<div key={sectionTitle} className="list-group">
						<h6 className="dropdown-header text-white bg-dark">{sectionTitle}</h6>
						<div className="list-group">
							{linksMain}
						</div>
					</div>)
			}
		}

		routes.push(index);
		return {"ctn": routes, "menuTop": linksTop, "menuLeft": menuOut, "admin": admin};
	}
}

export default MainMenu;
